var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vxe-grid',_vm._b({ref:"xTable",attrs:{"data":_vm.tableData,"height":_vm.tableHeight,"loading":_vm.loading}},'vxe-grid',_vm.gridOptions,false))}
var staticRenderFns = []

export { render, staticRenderFns }